import React from 'react';
import Schedule from './Schedule/Schedule';
function ScheduleHome() {
  return <Schedule />;
}

export default ScheduleHome;
